import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import BodyComponent from './TopStoresBody'
import { Header, HeaderLabel, HeaderIcon, Brand, Body } from './TopStores.style'
import { BlueBox } from '../common'
import { Padding } from '../../../..'

const TopStores = ({ isEmpty, loading, onClickHeader, stores, t }) => (
    <BlueBox loading={loading} noResults={isEmpty}>
        <Padding fullHeight>
            <Header>
                <HeaderLabel onClick={onClickHeader}>
                    {t('Top 5 Stores')}
                    <HeaderIcon icon="random" />
                </HeaderLabel>
                <Brand />
            </Header>
            <Body>
                <BodyComponent isEmpty={isEmpty} stores={stores} />
            </Body>
        </Padding>
    </BlueBox>
)

TopStores.propTypes = {
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    onClickHeader: PropTypes.func,
    stores: PropTypes.arrayOf(
        PropTypes.shape({
            store_code: PropTypes.string,
            unique_visitors: PropTypes.number,
            deviceCount: PropTypes.number,
            rating: PropTypes.string,
        })
    ),
    t: PropTypes.func.isRequired,
}

TopStores.defaultProps = {
    isEmpty: true,
    loading: null,
    onClickHeader: () => null,
    stores: [],
}

export default withTranslation()(TopStores)
